const DOCUMENT_TITLE = {
    DEFAULT: 'HW Community',
    NOT_FOUND: 'Page not found :(',
    FEED: 'Feed',
    COOKIE_POLICY: 'Cookie policy'
}

export default DOCUMENT_TITLE
